import React from "react";
import RADElementEditor from "./RADElementEditor.jsx";
import RADDataEditor from "./RADDataEditor.jsx";
import { CollapsibleContainer } from "@cadenza/ui";
import { useLanguageContext } from "@cadenza/i18n-react";
import { TRANSLATION_KEYS as T } from "@cadenza/i18n-core";

const RADEditor = () => {
  const { STRINGS = {} } = useLanguageContext() || {};

  const NAME = STRINGS[T.NAME] || "Name";
  const DESCRIPTION = STRINGS[T.DESCRIPTION] || "Description";
  const VIEWPOINT = STRINGS[T.MODEL_VIEWPOINT] || "Viewport";
  const words = { NAME, DESCRIPTION, VIEWPOINT };
  return (
    <CollapsibleContainer
      label="Data Editor"
      direction="horizontal"
      side="right"
      initialCollapsed={false}
    >
      <div className="rad-editor">
        <RADDataEditor words={words} />
        <RADElementEditor words={words} />
      </div>
    </CollapsibleContainer>
  );
};

export default RADEditor;
